// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"CheckDetailModal--next-sr-only--1ELIkqS","widthFull":"CheckDetailModal--widthFull--3ZubBxQ","closeModalButton":"CheckDetailModal--closeModalButton--2pwX0BL"};